<template>
    <div class="social-media-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Social Media Services From Epwin
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-epwin.png">
                </div>
            </div>
            <div class="box-1">
                <h1>
                    Want to make more of social media in your marketing activity?
                </h1>
                <p>
                    Get ideas and best practice guidelines from the Epwin Window Systems award-winning marketing team.
                </p>
                <div>
                    <a class="btn-primary _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/social-media-page-image-1.png">
            </div>
            <div class="box-2">
                <p>
                    Whether you’ve posted information on a social media site about a product launch, driven
                    readership by posting a link to your blog or simply shared a photograph of your internal
                    teams, you’ve leveraged social media for the good of your brand.
                </p>
                <p>
                    Use of social media sites – both on the part of consumers and businesses – has
                    increased dramatically in recent years. And with more advancements being added to top
                    platforms like Facebook, Instagram, X (Twitter) and LinkedIn, it’s safe to say that social isn’t
                    going anywhere.
                </p>
                <p>
                    Our award-winning marketing team can help you with your social strategy. From
                    guidance on best practices, helping you develop compelling content or providing a full
                    social strategy, we are here to help kick start your social campaign.
                </p>
                <div>
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Social Media Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I am interested in working on my Social Media Strategy with Epwin.',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 4,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Social Media enquiry',
                'value': 'Social Media enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
    },
};
</script>
